module.exports = __webpack_public_path__ + "img/address.c5491056.png";